<template>
    <!-- {{ singleDataTree }} -->
    <div v-show="isSearchAble">
        <input
            type="text"
            placeholder="Search Tags"
            class="searchInput"
            @keyup="searchSmartTag"
        />
    </div>
    <div class="!p-4">
        <!-- <VDropdown
            class="multi_dropdown"
            :distance="0"
            :skidding="0"
            placement="right-start"
            :prevent-overflow="false"
            :overflow-padding="0"
            auto-boundary-max-size
        > -->

        <template
            v-for="(itemSingle, indexSingle) in groupedArray"
            :key="indexSingle"
        >
            <div class="single_content relative border-gray-200">
                <!-- {{ itemSingle }} -->
                <!-- <fa v-if="item.icon" :icon="['fal', item.icon]"></fa> -->
                <p
                    class="text-xs font-bold text-gray-navtext p-2 mb-0.5"
                >
				TIMELINE TAGS 
                </p>
                <template
                    v-for="(itemVal, indexVal) in itemSingle.values"
                    :key="indexVal"
                >
				
				
				<div
                        class="flex items-center p-2 mb-0.5 hover:bg-gray-100 rounded-lg cursor-pointer"
                        @click="handleClickMethod(itemVal)"
                    >
					<LabelInfo />
                        <!-- <fa
                            v-if="itemVal.icon"
                            class="text-lg text-gray-navtext mr-1"
                            :icon="['fal', itemVal.icon]"
                        ></fa>
                        <div class="flex flex-col">
                            <span class="text-xs font-light text-dark-100">{{
                                itemVal.tag_name?.replace(/_/g, ' ')
                            }}</span>
                            <div
                                v-if="itemVal.tag_value"
                                v-html="itemVal.tag_value"
                                class="text-sm text-dark-100 italic"
                            ></div>
                        </div> -->
                    </div>
                </template>
                <!-- <fa
                        v-if="item.subnav.length > 0"
                        class="ml-auto !text-[0.625rem]"
                        :icon="['fal', 'angle-right']"
                    ></fa> -->
            </div>
        </template>
        <!-- </VDropdown> -->
    </div>
</template>

<script setup>
import LabelInfo from '../LabelInfo.vue';
import { ref, watch } from 'vue';
const emit = defineEmits(['handleClick', 'SearchTag']);
import { findParentPath } from '@/composables/globals';
const props = defineProps({
    dataTree: {
        type: Array,
        required: false,
    },
    singleDataTree: {
        type: Array,
        required: false,
    },
    isSearchAble: {
        type: Boolean,
        required: false,
        default: false,
    },
    showPopper: {
        type: Boolean,
        default: false,
    },
    headingText: {
        type: String,
        default: '',
    },
    isHeading: {
        type: Boolean,
        default: false,
    },
    smartClass: {
        type: String,
        default: '',
    },
    isMultiple: {
        type: Boolean,
        default: true,
    },
});
console.log('check_vaue')
// handle click emit
const handleClick = (value) => {
    console.log('handle click popper called');
    emit('handleClick', value);
};
const handleClickMethod = (value) => {
    if(props.isMultiple){
        const pathToItem = findParentPath(props.dataTree, value.levels);
        emit('pathToItemClick', pathToItem)
        console.log(pathToItem, value, 'handleClickMethod');
    }
    emit('handleClick', value);
};
const searchSmartTag = (v) => {
    emit('SearchTag', v);
};
watch(
    () => props.singleDataTree,
    () => {
        group_arrey();
    }
);

const dropdownSingle = ref([]);
const groupedArray = ref([]);

const group_arrey = () => {
    console.log(props.singleDataTree, 'b1');
    if (props.singleDataTree) {
        dropdownSingle.value = [...props.singleDataTree];
        // Create an object to store grouped values
        const groupedData = {};

        // // Iterate through the data and group by title
        dropdownSingle.value.forEach((item) => {
            const { type, ...items } = item;
            if (!groupedData[type]) {
                groupedData[type] = [];
            }
            groupedData[type].push(items);
        });

        // // Convert the grouped object into an array of objects
        groupedArray.value = Object.keys(groupedData).map((type) => ({
            type,
            values: groupedData[type],
        }));
    }
    console.log(groupedArray.value, 'b1');
};
group_arrey();

// console.log(groupedArray,'group_arrey');
</script>

<style scoped>
.searchInput {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="%23BAC4CD"><path d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"/></svg>');
    background-position: 16px 16px;
    background-repeat: no-repeat;
    padding: 16px 16px 16px 42px;
    @apply !text-sm !text-dark-100 !h-[3.0625rem] outline-none border-b border-gray-200 w-full;
}
.multi_dropdown {
    @apply mb-0.5;
}
.multi_dropdown .multi_dropdown_content {
    @apply p-2 h-10 flex cursor-pointer items-center hover:bg-gray-100 rounded-lg;
}
.multi_dropdown_content svg {
    @apply text-lg text-gray-100 mr-1;
}
.multi_dropdown_content p {
    @apply text-sm text-dark-100 italic;
}
</style>
